import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
// import { ImageItem } from "@app/types";
import { IcAlert, IcLaptop, IcSettings, IcSmartphone, IcWindows, IcX } from "../icons";

function TunnelModal({ portalDialogRef, portalData }: PortalDialogProps) {
  // const image: ImageItem = portalData;

  // Chọn là thực hiện luôn, không hỏi lại bằng hộp xác nhận
  const handleClickWin = (os: string) => {
    portalDialogRef.close({ os });
  };

  // Giữ nguyên giá trị os gửi lên như bản cũ: win / mac / mobile / config
  const options: [string, string, JSX.Element][] = [
    ["win", "Windows", <IcWindows key="win" className="h-6 w-6" />],
    ["mac", "MacOS", <IcLaptop key="mac" className="h-6 w-6" />],
    ["mobile", "Mobile", <IcSmartphone key="mobile" className="h-6 w-6" />],
    ["config", "File.config", <IcSettings key="config" className="h-6 w-6" />],
  ];

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren={false}>
      <div className="flex w-[min(700px,calc(100vw-32px))] flex-col text-fg">
        <div className="flex items-start justify-between gap-3 border-b border-line px-6 pb-4 pt-5">
          <div>
            <h2 className="text-[19px] font-bold">PCRender Tunnel</h2>
            {portalData?.name && <p className="m-0 mt-0.5 text-[13px] text-muted">{portalData.name}</p>}
          </div>
          <button
            type="button"
            aria-label="Đóng"
            className="grid h-8 w-8 place-items-center rounded-lg border border-line bg-surface text-fg hover:bg-surface-2"
            onClick={() => portalDialogRef.close()}
          >
            <IcX className="h-4 w-4" />
          </button>
        </div>

        <div className="flex flex-col gap-3 px-6 py-5 text-[15px] leading-relaxed text-muted">
          <div className="grid grid-cols-4 gap-3 max-[560px]:grid-cols-2">
            {options.map(([os, label, icon]) => (
              <button
                key={os}
                type="button"
                className="flex flex-col items-center justify-center gap-2 rounded-xl border border-brand-line bg-brand-soft px-3 py-4 text-[15px] font-semibold text-brand transition-colors hover:bg-brand hover:text-white"
                onClick={() => handleClickWin(os)}
              >
                {icon}
                {label}
              </button>
            ))}
          </div>
          <p className="m-0">
            PCRender Tunnel là một mạng riêng ảo cho phép kết nối trực tiếp máy của bạn đến máy thuê.
          </p>
          <p className="m-0">Ngoài ra có thể giúp bạn bỏ qua NAT khi kết nối Parsec và giảm tới 1/3 độ trễ.</p>
          <p className="m-0">
            Để sử dụng tính năng này, vui lòng chọn hệ điều hành tương ứng mà bạn đang sử dụng để tải về cài đặt.
          </p>
          <div className="flex items-start gap-2 rounded-xl bg-bad-soft px-4 py-3 text-[14px] text-bad">
            <IcAlert className="mt-0.5 h-[18px] w-[18px] flex-none" />
            <span>
              <b>Lưu ý:</b> Trước khi tải, cài đặt PCRender Tunnel cần tắt diệt virus của hệ điều hành bạn đang sử dụng.
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default TunnelModal;
